import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { Repeat, ArrowRight, Car } from "lucide-react";
import { api } from "@/lib/api";
import { swapImageUrl } from "./GestioneSwap";

const fmt = (n) => Math.round(Number(n || 0)).toLocaleString("it-IT");

export default function SwapPage() {
  const [swaps, setSwaps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/swaps").then(({ data }) => setSwaps(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="w-full">
      <PageHeader
        icon={Repeat}
        title="Swap"
        subtitle="Modelli concessionario e relativa conversione swap disponibile."
        right={
          <div className="ot-label flex items-center gap-2">
            <span className="w-2 h-2 bg-emerald-400 rounded-full" />
            {swaps.length} MODELLI
          </div>
        }
      />

      {loading ? (
        <div className="py-16 text-center text-slate-500 ot-mono text-sm">CARICAMENTO...</div>
      ) : swaps.length === 0 ? (
        <div className="ot-panel-elev p-10 sm:p-16 flex flex-col items-center justify-center text-center ot-fade-up" data-testid="swap-soon">
          <div className="ot-heading font-black uppercase leading-none tracking-tighter text-blue-400 text-[22vw] sm:text-[14vw] lg:text-[11rem]" style={{ textShadow: "0 0 60px rgba(47,107,255,0.55)" }}>
            SOON
          </div>
          <div className="ot-mono text-xs sm:text-sm text-slate-400 tracking-[0.35em] mt-4">SWAP IN ARRIVO</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5" data-testid="swaps-list">
          {swaps.map((s, idx) => (
            <div key={s.id} className="ot-panel-elev overflow-hidden ot-fade-up" style={{ animationDelay: `${idx * 60}ms` }} data-testid={`swap-card-${s.id}`}>
              <div className="relative h-44 overflow-hidden">
                {s.image_path ? (
                  <img src={swapImageUrl(s.image_path)} alt={s.target_name} loading="lazy" className="w-full h-full object-cover opacity-90 hover:scale-105 transition-transform duration-500" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-500/20 via-blue-600/10 to-transparent">
                    <Car className="w-10 h-10 text-slate-500" />
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#060a1c] via-transparent to-transparent" />
                <div className="absolute bottom-3 left-4 right-4 ot-heading text-xl font-black uppercase tracking-tighter text-slate-100 leading-tight" style={{ textShadow: "0 2px 12px rgba(0,0,0,0.9)" }}>
                  {s.target_name}
                </div>
              </div>

              <div className="p-4 space-y-3">
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <div className="ot-label mb-0.5">1 · ACQUISTO CONCESSIONARIO</div>
                    <div className="text-slate-100 font-bold ot-heading uppercase text-sm">{s.base_name || "—"}</div>
                  </div>
                  <div className="ot-mono font-bold text-slate-300 text-sm">${fmt(s.dealer_price)}</div>
                </div>

                <div className="flex items-center gap-2 text-blue-400">
                  <div className="flex-1 h-px bg-gradient-to-r from-transparent to-blue-400/40" />
                  <ArrowRight className="w-4 h-4 ot-blink" />
                  <div className="flex-1 h-px bg-gradient-to-l from-transparent to-blue-400/40" />
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <div className="ot-label mb-0.5">2 · SWAP IN OFFICINA</div>
                    <div className="text-blue-400 font-bold ot-heading uppercase text-sm">{s.target_name}</div>
                  </div>
                  <div className="ot-mono font-bold text-blue-400 text-sm">${fmt(s.workshop_price)}</div>
                </div>

                <div className="ot-panel p-3 flex items-center justify-between">
                  <div className="ot-label">COSTO TOTALE CLIENTE</div>
                  <div className="ot-mono font-black text-lg text-amber-400">${fmt(s.total)}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-8 ot-mono text-[0.7rem] text-slate-500 tracking-widest text-center">
        // IN FATTURA VIENE CONTEGGIATO SOLO IL PREZZO OFFICINA · SEZIONE FATTURE
      </div>
    </div>
  );
}
